import {FC, useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  SelectWrapper,
  InputTextWrapper,
  InputNumberWrapper,
} from '../../../../../../components/UI/Form/Input'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {SelectOption} from '../../../../../../models/utility.model'
import {formatDateType2} from '../../../../../../util/dates'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {useModules} from '../../../../hooks/useModules'
import {getModuleByIdService} from '../../../../services/module.service'
import {getRoomByIdService} from '../../services/getRoomById.service'
import AditionalCamp from '../../../../../../components/UI/Form/aditionalCamp'

const FormRoom: FC = () => {
  const {currentTabItem} = useHoteleria()

  const [sites, setSites] = useState<SelectOption[]>([])
  const [camps, setCamps] = useState<SelectOption[]>([])
  const [moduleType, setModuleType] = useState<SelectOption[]>([])
  const [level, setLevel] = useState<SelectOption[]>([])
  const [preasignationType, setPreasignationType] = useState<SelectOption[]>([])
  const [genre, setGenre] = useState<SelectOption[]>([])
  const [bathroomType, setBathroomType] = useState<SelectOption[]>([])
  const [roomType, setRoomType] = useState<SelectOption[]>([])
  const [statusRoom, setStatusRoom] = useState<SelectOption[]>([])
  const [subStatusRoom, setSubStatusRoom] = useState<SelectOption[]>([])
  const [modules, setModules] = useState<SelectOption[]>([])
  const [turns, setTurns] = useState<SelectOption[]>([{value: '', label: 'CUALQUIERA'}])
  const [cargos, setCargos] = useState<SelectOption[]>([{value: '', label: 'CUALQUIERA'}])
  const [company, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [receptionistComp, setReceptionistComp] = useState<SelectOption[]>([
    {value: '', label: 'CUALQUIERA'},
  ])

  const {setValue, setError, watch} = useFormContext()
  const {getCompanies, getClients, getSites, getCamps, getMasterTable, getReceptionist} =
    useCentralServices()
  const {getModules} = useModules()

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    setCompany(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
      await getReceptionistFn(data[0].value as string)
    }
    setClient(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
    }
    setSites(data)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value)
      setError('CampamentoId', {})
      getModulesFn(data[0].value as string)
    }
    setCamps(data)
  }

  const getModulesFn = async (campamentoId: string) => {
    const data = await getModules({CampamentoId: campamentoId})
    setModules(data)
  }

  const getModuleTypesFn = async () => {
    const data = await getMasterTable('TipoModulo', true)
    setModuleType(data)
  }

  const getLevelsFn = async (level: number) => {
    const data = await getMasterTable('Nivel', true)
    const orderedData = data.sort((a, b) => parseInt(a.codigo) - parseInt(b.codigo))
    const filterData = orderedData.slice(0, level)
    setLevel(filterData)
  }

  const getPreasignationTypesFn = async () => {
    const data = await getMasterTable('TipoPreasignacion', true)
    setPreasignationType(data)
  }

  const getGenresFn = async () => {
    const data = await getMasterTable('Sexo', true)
    setGenre(data)
  }

  const getCargosFn = async () => {
    const data = await getMasterTable('Cargo', true)
    const allData = [{value: '', label: 'CUALQUIERA'}, ...data]
    setCargos(allData)
  }

  const getTurnsFn = async () => {
    const data = await getMasterTable('Turno', true)
    const allData = [{value: '', label: 'CUALQUIERA'}, ...data]
    setTurns(allData)
  }

  const getBathroomsTypeFn = async () => {
    const data = await getMasterTable('TipoBanio', true)
    setBathroomType(data)
  }

  const getRoomsTypeFn = async () => {
    const data = await getMasterTable('TipoHabitacion', true)
    setRoomType(data)
  }

  const getStatusRoomFn = async () => {
    const data = await getMasterTable('EstadoHabitacion', true)
    setStatusRoom(data)
  }

  const getSubStatusRoomFn = async (codigoPadre: string) => {
    const data = await getMasterTable('SubEstadoHabitacion', true, {codigoPadre})
    setSubStatusRoom(data)
  }

  const getReceptionistFn = async (clienteId: string) => {
    const data = await getReceptionist(
      {clienteId: clienteId, companiaId: watch('CompaniaId') || null, isCombo: true},
      1,
      true,
    )
    const allData = [{value: '', label: 'CUALQUIERA'}, ...data]
    setReceptionistComp(allData)
  }

  useEffect(() => {
    getModuleTypesFn()
    getPreasignationTypesFn()
    getGenresFn()
    getBathroomsTypeFn()
    getRoomsTypeFn()
    getStatusRoomFn()
    getCompaniesFn()
    getTurnsFn()
    getCargosFn()
  }, [])

  useEffect(() => {
    if (statusRoom.length > 0) {
      const defaultStatus = statusRoom.find((item: any) => item.label === 'DISPONIBLE')?.value
      const filtered =
        statusRoom.filter((item: any) => item.value === defaultStatus)[0]?.codigo || ''
      getSubStatusRoomFn(filtered)
      if (!currentTabItem.idToEdit) {
        setValue('EstadoHabitacionId', defaultStatus)
      }
    }
  }, [statusRoom])

  useEffect(() => {
    if (subStatusRoom.length > 0) {
      const defaultStatus = subStatusRoom.find((item: any) => item.label === 'HABILITADA')?.value
      if (!currentTabItem.idToEdit) {
        setValue('SubEstadoHabitacionId', defaultStatus)
      }
    }
  }, [subStatusRoom])

  const getRoomById = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getRoomByIdService(idToEdit as any)
        const {
          SiteId,
          TipoModuloId,
          TipoHabitacionId,
          Codigo,
          EstadoHabitacionId,
          SubEstadoHabitacionId,
          TipoPreAsignacionId,
          SexoId,
          TipoBanioId,
          NivelId,
          NroCamas,
          PrioridadAsignacion,
          PrioridadAsignacionId,
          ModuloId,
          CompaniaId,
          ClienteId,
          CampamentoId,
          LotizacionEmpresaId,
          TurnoId,
          CargoId,
          Campoadicionaltxt1,
          Campoadicionaltxt2,
          Campoadicionaltxt3,
          Campoadicionaltxt4,
          Campoadicionaltxt5,
          Campoadicionalnum1,
          Campoadicionalnum2,
          Campoadicionalnum3,
          CampoadicionalFec1,
          CampoadicionalFec2,
        } = data
        setValue('Id', idToEdit)
        setValue('ModuloId', ModuloId)
        setValue('CampamentoId', CampamentoId)
        setValue('SiteId', SiteId)
        setValue('TipoModuloId', TipoModuloId)
        setValue('TipoHabitacionId', TipoHabitacionId)
        setValue('Codigo', Codigo)
        setValue('EstadoHabitacionId', EstadoHabitacionId)
        setValue('SubEstadoHabitacionId', SubEstadoHabitacionId)
        setValue('TipoPreAsignacionId', TipoPreAsignacionId)
        setValue('SexoId', SexoId)
        setValue('TipoBanioId', TipoBanioId)
        setValue('NivelId', NivelId)
        setValue('NroCamas', NroCamas)
        setValue('PrioridadAsignacionId', PrioridadAsignacionId)
        setValue('PrioridadAsignacion', PrioridadAsignacion)
        setValue('CompaniaId', CompaniaId)
        setValue('ClienteId', ClienteId)
        setValue('LotizacionEmpresaId', LotizacionEmpresaId || '')
        setValue('TurnoId', TurnoId || '')
        setValue('CargoId', CargoId || '')
        setValue('Campoadicionaltxt1', Campoadicionaltxt1)
        setValue('Campoadicionaltxt2', Campoadicionaltxt2)
        setValue('Campoadicionaltxt3', Campoadicionaltxt3)
        setValue('Campoadicionaltxt4', Campoadicionaltxt4)
        setValue('Campoadicionaltxt5', Campoadicionaltxt5)
        let num1 = Campoadicionalnum1 ? (Campoadicionalnum1 === 0 ? '' : Campoadicionalnum1) : ''
        let num2 = Campoadicionalnum2 ? (Campoadicionalnum2 === 0 ? '' : Campoadicionalnum2) : ''
        let num3 = Campoadicionalnum3 ? (Campoadicionalnum3 === 0 ? '' : Campoadicionalnum3) : ''
        setValue('Campoadicionalnum1', num1)
        setValue('Campoadicionalnum2', num2)
        setValue('Campoadicionalnum3', num3)
        setValue('CampoadicionalFec1', formatDateType2(CampoadicionalFec1))
        setValue('CampoadicionalFec2', formatDateType2(CampoadicionalFec2))
        getClientsFn(CompaniaId as any)
        getSitesFn(ClienteId as any)
        getCampsFn(SiteId as any)
        getModulesFn(CampamentoId as any)
        getReceptionistFn(ClienteId as any)
        getLevelsByModule(ModuloId as any)
        const filtered =
          statusRoom.filter((item: any) => item.value === EstadoHabitacionId)[0]?.codigo || ''
        getSubStatusRoomFn(filtered)
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (currentTabItem.idToEdit && statusRoom.length > 0) {
      getRoomById()
    }
  }, [currentTabItem.idToEdit, statusRoom])

  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setSites([])
    setValue('CampamentoId', '')
    setCamps([])
    setError('CompaniaId', {})
    getClientsFn(value)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    getReceptionistFn(value)
    setValue('ClienteId', value)
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setCamps([])
    setError('ClienteId', {})
    getSitesFn(value)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)
    setValue('CampamentoId', '')
    getCampsFn(value)
    setError('SiteId', {})
  }

  const handleCampChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CampamentoId', value)
    getModulesFn(value)
    setError('CampamentoId', {})
  }

  const handleStatusChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('EstadoHabitacionId', value)
    setValue('SubEstadoHabitacionId', '')
    setError('EstadoHabitacionId', {})
    const filtered = statusRoom.filter((item: any) => item.value === value)[0]?.codigo || ''
    getSubStatusRoomFn(filtered)
  }

  const handleModuleChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ModuloId', value)
    setError('ModuloId', {})
    setValue('NivelId', '')
    setError('NivelId', {})
    getModuleById(value)
  }

  const getModuleById = async (moduleId: string) => {
    try {
      const {
        data: {data},
      } = await getModuleByIdService(moduleId)
      const {TipoModuloId, NroPisos} = data
      setValue('TipoModuloId', TipoModuloId)
      setError('TipoModuloId', {})
      const filteredTypeModule = moduleType.find((item: any) => item.value === TipoModuloId)?.label
      const filteredRoomType = roomType.find(
        (item: any) => item.label === filteredTypeModule,
      )?.value
      setValue('TipoHabitacionId', filteredRoomType)
      setError('TipoHabitacionId', {})
      getLevelsFn(NroPisos || 0)
    } catch (error) {}
  }

  const getLevelsByModule = async (moduleId: string) => {
    try {
      const {
        data: {data},
      } = await getModuleByIdService(moduleId)
      const {NroPisos} = data
      getLevelsFn(NroPisos || 0)
    } catch (error) {}
  }

  return (
    <div className='sdx_form card p-4'>
      <div className='row'>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Compañía'
            name='CompaniaId'
            data={company}
            onChangeValue={handleCompanyChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Cliente'
            name='ClienteId'
            data={client}
            onChangeValue={handleClientChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Site'
            name='SiteId'
            data={sites}
            onChangeValue={handleSiteChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Campamento'
            name='CampamentoId'
            data={camps}
            onChangeValue={handleCampChange}
            required
          />
        </div>
      </div>
      <div className='row'>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Nomenclatura Módulo'
            name='ModuloId'
            data={modules}
            onChangeValue={handleModuleChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo de Módulo'
            name='TipoModuloId'
            data={moduleType}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo de Habitación'
            name='TipoHabitacionId'
            data={roomType}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Nomenclatura de Habitación'
            name='Codigo'
            textPlaceholder='Escribe el Codigo'
            type='ticketNumber'
            required
          />
        </div>
      </div>
      <div className='row'>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Estado'
            name='EstadoHabitacionId'
            data={statusRoom}
            onChangeValue={handleStatusChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Sub Estado'
            name='SubEstadoHabitacionId'
            data={subStatusRoom}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Preasignación'
            name='TipoPreAsignacionId'
            data={preasignationType}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Sexo' name='SexoId' data={genre} required />
        </div>
      </div>
      <div className='row'>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Empresa Lotización'
            name='LotizacionEmpresaId'
            data={receptionistComp}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Cargo' name='CargoId' data={cargos} required />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Turno' name='TurnoId' data={turns} required />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Tipo de Baño' name='TipoBanioId' data={bathroomType} required />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Piso' name='NivelId' data={level} required />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Nro de Camas'
            name='NroCamas'
            textPlaceholder='Escribe el Numero de Camas'
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Nro de Secuencia de Asignación'
            name='PrioridadAsignacion'
            textPlaceholder='Escribe el Numero de Secuencia de Asignación'
            required
          />
        </div>
      </div>
      <hr className='divider' />
      <AditionalCamp module='hoteleria' />
    </div>
  )
}

export {FormRoom}
